import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route, Redirect,Navigate
} from "react-router-dom";
import Home from './Home';
import Contact from './Contact';
import HeaderMenuHeader from './HeaderMenuHeader';
import About_us from './About_us';

const abgrcs_content = ReactDOM.createRoot(document.getElementById('abgrcs_content'));
const root = ReactDOM.createRoot(document.getElementById('abgrcs_header'));

abgrcs_content.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/Contact' element={<Contact />} />
        <Route path='/about_us' element={<About_us />} />
        <Route path='/home' element={<Home />} />
        <Route exact path='*' element={<Home />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

root.render(
  <React.StrictMode>
    <HeaderMenuHeader />
  </React.StrictMode>
);